export default {
  // states must be split by company because
  // they might vary from vendor, distributor and reseller and multiple
  // forms can exist in DOM shadows
  companies: {
    /*

    '/distributor/2000074' for example is the unique identifier of a company we're
    calling companyKey

    here an example what the state could look like for one active company:

    '/distributor/2000074': {
      loading: false,
      creating: false,
      renameTarget: null,
      uri: 'https://localhost:3000/api/distributor/2000074/tenancies'
      list: []
    }
    */
  }
}
